<template>
  <div>
    <router-view class="view" keep-alive transition transition-mode="out-in" />
    <page-listar v-if="isIndexOnly()" />
  </div>
</template>

<script>
import Novo from './Novo.vue'

export default {
  name: 'campanhas',
  data () {
    return {
      title: 'Campanhas'
    }
  },
  components: {
    'page-listar': Novo
  },
  methods: {
    isIndexOnly () {
      return this.$router.currentRoute.path === '/campanhas' || this.$router.currentRoute.path === '/campanhas/'
    }
  },
  mounted () {
    this.$parent.$data.title = this.title
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/campanhas/index.vue